import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionCta } from './CtaButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-teal-light px-2 py-16 sm:px-5 sm:py-20" aria-labelledby="bonus-title" data-id="element-56" data-mp="plsjs38jiy8p">
      <div className="mx-auto max-w-6xl" data-id="element-57" data-mp="at8ti36hol8o">
        <div className="mx-auto max-w-3xl px-3 text-center" data-id="element-58" data-mp="ft4o5btar0bk">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-cta text-white shadow-cta" data-id="element-59" data-mp="1uet01q1fapu">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-60" data-mp="5wi6sx06irea" />
          </span>
          <h2 id="bonus-title" className="mt-5 text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-61" data-mp="3o1lgkv13brl1">
            YOUR EXCLUSIVE AAC BLUEPRINT BONUSES
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-62" data-mp="3t2j5dqglvjvi">
            Five additional resources to complement your six-volume collection.
          </p>
        </div>

        <div className="mt-10 space-y-6" data-id="element-63" data-mp="1r8jwfbqyhelz">
          {bonuses.map((b, i) => <article key={b.number} className="grid overflow-hidden rounded-3xl bg-white shadow-card md:grid-cols-2 md:items-center" data-id="element-64" data-mp="3id53r416cz9q" data-mpi={i}>
              <div className={`bg-white ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-65" data-mp="3r6zzjlgepdcp">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-66" data-mp="3n5eqkb6ztj7s" />
              </div>
              <div className="px-5 pb-7 pt-2 sm:px-8 md:py-10" data-id="element-67" data-mp="2uhixrhkjobga">
                <span className="inline-block rounded-lg bg-navy px-3 py-1 text-sm font-black uppercase tracking-wide text-white" data-id="element-68" data-mp="38g8qym48tqzd">
                  Bonus #{b.number}
                </span>
                <h3 className="mt-4 text-[24px] font-black leading-tight text-ink sm:text-[28px]" data-id="element-69" data-mp="33jibo109izf0">{b.title}</h3>
                <p className="mt-3 text-[17px] font-bold leading-snug text-teal" data-id="element-70" data-mp="ir6ty1nm5maf">{b.lead}</p>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-71" data-mp="3ciwqsol3rhim">{b.body}</p>
                <div className="mt-6 flex flex-wrap items-center gap-3 border-t border-navy/10 pt-5" data-id="element-72" data-mp="3cl958rrnj9qx">
                  <span className="text-[15px] text-muted" data-id="element-73" data-mp="3hju52q2zrreu">
                    Suggested reference value: <s className="font-bold text-danger" data-id="element-74" data-mp="3lhi4a5bpw6cj">${b.value}</s>
                  </span>
                  <span className="rounded-full bg-success px-3 py-1 text-sm font-black uppercase text-white" data-id="element-75" data-mp="3qglbnwf66ono">
                    Included
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="px-3" data-id="element-76" data-mp="32sv0dq5a1n0j">
          <SectionCta label="Yes! Give me the five bonuses" data-id="element-77" data-mp="32rjwlqbu0f9f" />
        </div>
      </div>
    </section>;
}